import React, { useEffect, useState } from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { decode } from "he";
import { Button, Input } from "ii-ui-kit";
import { useForm } from "react-hook-form";
import { SubmitHandler } from "react-hook-form/dist/types/form";

import { confirmDocumentFormSchema } from "consts";
import { clearFormError } from "utils/clear-form-error/clear-form-error";
import { postForm } from "utils/post-form/post-form";

import "./confirm-document-page.scss";
import { BackButton } from "../../components/back-button/back-button";

import { buildErrorMessage } from "./utils";

export interface IConfirmDocumentsFormFields {
  passport: string;
}

export const ConfirmDocumentPage = () => {
  /** Форма отправляется ? */
  const [isFormSending, setIsFormSending] = useState(false);
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm<IConfirmDocumentsFormFields>({
    mode: "onBlur",
    resolver: yupResolver(confirmDocumentFormSchema),
  });

  useEffect(() => {
    const match = window.error?.match(/docAuthCodeInvalid(\d+)/);
    if (match && match[1]) {
      setError("passport", {
        message: buildErrorMessage(Number(match[1])),
      });
    }
  }, [window.error]);

  const onSubmit: SubmitHandler<IConfirmDocumentsFormFields> = (data) => {
    if (!window.loginAction) {
      return;
    }

    setIsFormSending(true);

    const preparedData = {
      code: data.passport.replaceAll(/\D/g, ""),
    };
    clearFormError();
    postForm(
      window.loginAction ? decode(window.loginAction) : "",
      preparedData
    );
  };

  return (
    <div className="confirm-document-page">
      <div className="confirm-document-page__title">Восстановление пароля</div>
      <div className="confirm-document-page__text">
        Введите 6 последних цифр номера паспорта
      </div>
      <form
        className={"confirm-document-page__form"}
        onSubmit={handleSubmit(onSubmit)}
      >
        <Input
          id={"passport"}
          addContainerClass={"confirm-document-page__input"}
          mask={"XXXX 9 9 9 9 9 9"}
          label={"Номер паспорта"}
          placeholder={"Номер паспорта"}
          autoFocus={true}
          inputMode={"numeric"}
          form={"confirmDocument"}
          errorText={errors["passport"]?.message}
          validationStatus={errors["passport"] ? "error" : undefined}
          {...register("passport")}
        />
        <div className="confirm-document-page__buttons">
          <BackButton className={"confirm-document-page__back-button"} />
          <Button
            isLoading={isFormSending}
            className={"confirm-document-page__button"}
            title={"Восстановить пароль"}
            size={"m"}
          />
        </div>
      </form>
    </div>
  );
};
